@if (label) {
  <app-control-header
    [label]="label"
    [labelWithColon]="labelWithColon"
    [icon]="labelIcon"
    [index]="index"
    [required]="required"
    [descriptionTooltipText]="descriptionTooltipText"
  ></app-control-header>
}

<div
  class="wrapper"
  [class.is-disabled]="isDisabled$ | async"
  [class.file-changed]="value"
  [ngClass]="{ 'border border-solid border-pink-70': errorsDisplayed }"
  (click)="selectFile()"
>
  <input
    #fileUploadField
    id="{{ fieldName }}-fileField"
    hidden
    type="file"
    [accept]="acceptedFileExtensionsString"
    [disabled]="isDisabled$ | async"
    (change)="uploadFile()"
  />
  <div class="text-wrapper">
    @if (value) {
      <span class="file-name">{{ valueAsFile.name }}</span>
    } @else {
      <span>{{ buildTranslationKey('selectFile') | translate }}</span>
    }
  </div>
</div>

@if (errorsDisplayed) {
  <app-control-errors
    [errorTexts]="errorTexts"
    [errorInfoIconTexts]="errorInfoIconTexts"
    [displayedErrorsLength]="1"
  ></app-control-errors>
}
